import React, {useState} from 'react';
import {MainPanelItem} from "../../../components";

const PanelMain = () => {

    const [logoutModal, setLogoutModal] = useState(false);

    return (
        <div className='container-md mt-4'>
            <MainPanelItem icon={<i className='icon-people' />}
                           alert
                           link='/panel/my-requests'
                           label='درخواست‌های من' />

            <MainPanelItem icon={<i className='icon-clipboard-tick-2' />}
                           link='/panel/my-shifts'
                           label='شیفت های قبول شده' />

            <MainPanelItem icon={<i className='icon-personalcard' />}
                           link='/panel/my-account'
                           label='اطلاعات حساب کاربری' />

            <MainPanelItem icon={<i className='icon-logout' />}
                           clickHandler={() => setLogoutModal(true)}
                           link='/'
                           label='خروج' />
        </div>
    );
};

export default PanelMain;
